import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../assets/css/VerifyEmail.css";
import { GetEmailVerify } from "../../api/userService";
import FullScreenLoader from "../../components/Common/Loader";

const VerifyMail = () => {
    const [heading, setHeading] = useState("Verify Your Account");
    const [details, setDetails] = useState("To complete your registration, please verify your account by clicking the button below.");
    const [image, setImage] = useState("/assets/images/User/mailverification.png");
    const [returnCode, setReturnCode] = useState(null);
    const [showAction, setShowAction] = useState(false);
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");
    const navigate = useNavigate();

    const handleVerify = async () => {
        if (!email) {
            setHeading("Invalid Verification Link");
            setDetails("Email address is missing or invalid.");
            setImage("/assets/images/User/mailfailed.png");
            setReturnCode("-1");
            setShowAction(true);
            return;
        }

        try {
            const payload = {
                EmailID: email,
                Source: global?.source || "web",
                Version: global?.appVersion || "1.0.0.0",
            };

            const response = await GetEmailVerify(payload);
            console.log("Reponse:", response);
            const zMessage = response?.zmessage?.[0];
            const rowMessage = response?.row?.[0];

            const code = rowMessage?.RETURNCODE || zMessage?.RETURNCODE || "-1";

            setHeading(rowMessage?.RETURNMESSAGE || "Verification Failed");
            setDetails(rowMessage?.RETURNDETAILS || "We couldn't verify your email.");
            setReturnCode(code);
            setShowAction(true);

            if (code === "1") {
                setImage("/assets/images/User/mailverified.png");
            } else if (code === "0") {
                setImage("/assets/images/User/mailwarning.png");
            } else {
                setImage("/assets/images/User/mailfailed.png");
            }
        } catch (error) {
            setHeading("Something Went Wrong");
            setDetails("Unable to complete verification. Please try again later.");
            setImage("/assets/images/User/mailfailed.png");
            setReturnCode("-2");
            setShowAction(true);
            console.log("error", error)
        } finally {
            setShowAction(false);
        }
    };

    const renderActionButton = () => {
        if (returnCode === "1") {
            return <button onClick={() => navigate("/login")}>Login</button>;
        } else if (returnCode === "0") {
            return <button onClick={() => navigate("/forget-password")}>Forgot Password</button>;
        } else {
            return <button onClick={() => navigate("/register")}>Create New Account</button>;
        }
    };

    return (
        <div className="verifyMail_main">
            <div className="verifyMail_container container">
                <div className="verifyMail_section">
                    <div className="verifyMail_card">
                        <div className="verifyMail_cardBody">
                            <div className="verifyMail_img">
                                <img src={image} alt="Mail Status" />
                            </div>

                            <div className="verifyMail_header">
                                <h2>{heading}</h2>
                            </div>

                            <div className="verifyMail_content">
                                <p>{details}</p>
                                {!showAction ? (
                                    <button onClick={handleVerify} className="btn-disabled">
                                       Verify Account Now
                                    </button>
                                ) : (
                                    renderActionButton()
                                )}
                            </div>
                            <div className="verifyMail_response">{/* Optional additional content */}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyMail;
